export const REMEMBER_EMAIL_KEY = 'remember-email'
export const USER_KEY = 'user'
export const ACCESS_TOKEN_KEY = 'accessToken'
export const REFRESH_TOKEN_KEY = 'refreshToken'
